import { toast, type ToastOptions } from 'react-toastify';

const AI_TOAST_OPTIONS: ToastOptions = {
  autoClose: 10_000,
};

export const aiToast = {
  success: (message: string, options?: ToastOptions) =>
    toast.success(message, { ...AI_TOAST_OPTIONS, ...options }),
  error: (message: string, options?: ToastOptions) =>
    toast.error(message, { ...AI_TOAST_OPTIONS, ...options }),
};
